module.exports = __webpack_public_path__ + "static/media/EduladeLogoNoBG.81fa543e.png";